import { useContextState } from "../../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()

    return {
        container: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            justifyContent: 'space-between',
            padding: '0 16px'
        },
        flex: {
            display: 'flex',
            alignItems: 'center',
        },
        title: {
            fontSize: '14px',
            color: colors.color13,
            wordBreak: 'break-word'
        },
        actionContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            padding: '16px 0',
        },
        keyValue: {
            '& .detail-value': {
                fontSize: '14px',
                fontWeight: 'bold',
                width: 'max-content'
            },
            '& .detail-caption': {
                fontSize: '12px',
                fontWeight: 'bold',
                width: 'max-content'
            }
        },
        dragIcon: {
            width: '30px',
            height: '35px',
            fontSize: '30px',
            fontWeight: 'thin',
            color: colors.color27,
            '& .MuiSvgIcon-root': {
                width: '1em',
                height: '1em',
                fontSize: '1em',
            }
        },
        actionIcons: {
            width: '25px',
            height: '25px',
            fontSize: '25px',
            fontWeight: 'thin',
            '& .MuiSvgIcon-root': {
                width: '1em',
                height: '1em',
                fontSize: '1em',
            }

        }
    }
}

export { useStyles }
